import { Button } from '../../../components/button'

export default function PasswordResetRequestSent({ onClose }) {
  return (
    <div className='wrapper'>
      <h1 className='title'>Check your email!</h1>
      <p className='description'>
        Please follow the link within the email to reset your password and continue.
      </p>
      <Button className='closeBtn' onClick={onClose}>
        Close
      </Button>

      <style jsx>{`
        .wrapper {
          position: relative;
          width: 43.6rem;
          padding: 2.6rem 0 4.1rem;
          background: #fff;
          border-radius: 1rem;

          :global(.closeBtn) {
            display: block;
            margin: 0 auto;
          }
        }

        .title {
          text-align: center;
          font-size: 3.2rem;
        }

        .description {
          max-width: 26.6rem;
          margin: 0.7rem auto 2.6rem;
          text-align: center;
          font-size: 1.6rem;

          .email {
            color: var(--text-link-color);
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            width: 100%;
            height: 100%;
            padding: 1.6rem 0 2.3rem;

            :global(.closeBtn) {
              position: fixed;
              bottom: 2.1rem;
              left: 1.2rem;
              width: calc(100vw - 2.4rem);
            }
          }
        }
      `}</style>
    </div>
  )
}
